import { Trans } from '@lingui/macro'
import PRICE_ORACLE_ABI from 'abis/governance/PriceOracle.json'
import { usePriceOracleContract } from 'hooks/useGovernanceContracts'

import ContractWidget from '../components/ContractWidget'
import { SectionTitle } from '../styleds'

export default function PriceOracleTab() {
  const contract = usePriceOracleContract()

  return (
    <>
      <SectionTitle>
        <Trans>PriceOracle Contract (0x...0112)</Trans>
      </SectionTitle>

      <ContractWidget
        title="PriceOracle"
        description="Price oracle for validator voting. Validators vote on daily HYDRA price which feeds into APR calculations."
        contract={contract}
        abi={PRICE_ORACLE_ABI as any}
        defaultFunction="shouldVote"
      />
    </>
  )
}
